// 用户账号状态
export const UserAccountStatus = {
  ACTIVE: 1,
  DISABLED: 0,
} as const;

export type UserAccountStatusValue = (typeof UserAccountStatus)[keyof typeof UserAccountStatus];

// 登录请求参数
export interface LoginRequest {
  phone: string;
  // 正常账号传短信验证码，禁用账号传固定密码
  code: string;
  device_id: string;
  invitation_code?: string;
}

// 发送验证码请求参数
export interface SendCodeRequest {
  phone: string;
  invitation_code?: string;
}

// 手机号注册状态响应
export interface PhoneRegistrationResponse {
  registered: boolean;
}

// 登录响应（wx-ai-user 返回的 data 字段）
export interface LoginResponse {
  token: string;
  expires_in: number;
  user: {
    uid: number;
    nickname: string;
    phone?: string;
    role?: UserTeamRole;
    roles?: UserTeamRole[];
    status?: UserAccountStatusValue;
  };
}

// 刷新 Token 响应
export interface RefreshTokenResponse {
  token: string;
  expires_in: number;
}

// Token 校验响应
export interface VerifyTokenResponse {
  valid: boolean;
  uid: number;
}

// 认证上下文值
export interface AuthContextValue {
  isAuthenticated: boolean;
  isLoading: boolean;
  uid: number | null;
  role: UserTeamRole;
  roles: UserTeamRole[];
  isAdmin: boolean;
  isLeader: boolean;
  login: (phone: string, code: string, invitationCode?: string) => Promise<void>;
  logout: () => Promise<void>;
  sendCode: (phone: string, invitationCode?: string) => Promise<void>;
}

// 认证错误码映射
export const AUTH_ERROR_MESSAGES: Record<number, string> = {
  1001: '手机号格式不正确',
  1002: '验证码发送过于频繁，请 60 秒后重试',
  1003: '今日发送次数已达上限',
  1004: '验证码已过期，请重新发送',
  1005: '验证码错误',
  1006: '验证码错误次数过多，请重新发送',
  1009: '短信发送失败，请稍后重试',
  1016: '账号已冻结，请联系管理员',
};

// 认证 API 错误响应
export interface AuthApiError {
  code: number;
  message: string;
  detail?: string;
}
import type { UserTeamRole } from './team';
